import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'

export const Loader = () => {
	return <Grid>
		<Row className="show-grid">
			<Col xs={12}>
				<div className='text-center'>
					<div className="lds-default">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			</Col>
		</Row>
	</Grid>
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.js